import type { TimeFrame } from "./types";
import { getTimeframeIntervalMs, needsJsAggregation } from "./aggregation";

/** 1m bars needed to produce `before` + `after` aggregated candles around anchor. */
export function compute1mLoadWindow(
  alignedAnchorMs: number,
  timeframe: TimeFrame,
  beforeCount: number,
  afterCount: number,
): { fromTs: number; toTs: number } {
  const tfMs = getTimeframeIntervalMs(timeframe) ?? 60_000;
  const spanBefore = Math.max(0, beforeCount) * tfMs;
  const spanAfter = Math.max(0, afterCount) * tfMs;
  const margin = needsJsAggregation(timeframe)
    ? 45 * 24 * 60 * 60_000
    : tfMs * 3;

  return {
    fromTs: alignedAnchorMs - spanBefore - margin,
    toTs: alignedAnchorMs + spanAfter + margin + tfMs,
  };
}
